export default function DiscoveryHubSearchTermSugestion() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6869 4.14645C15.8822 4.34171 15.8822 4.65829 15.6869 4.85355L9.35357 11.1869C9.15831 11.3821 8.84173 11.3821 8.64647 11.1869L5.66669 8.20711L1.02024 12.8536C0.824978 13.0488 0.508396 13.0488 0.313134 12.8536C0.117871 12.6583 0.117871 12.3417 0.313134 12.1464L5.31313 7.14645C5.5084 6.95118 5.82498 6.95118 6.02024 7.14645L9.00002 10.1262L14.9798 4.14645C15.1751 3.95118 15.4916 3.95118 15.6869 4.14645Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8333 4.5C10.8333 4.22386 11.0572 4 11.3333 4H15.3333C15.6095 4 15.8333 4.22386 15.8333 4.5V8.5C15.8333 8.77614 15.6095 9 15.3333 9C15.0572 9 14.8333 8.77614 14.8333 8.5V5H11.3333C11.0572 5 10.8333 4.77614 10.8333 4.5Z"
        fill="black"
      />
    </svg>
  )
}
